<script>
import SendSvg from "@/assets/img/icon/SendSvg.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
	components: { SendSvg },
	props: {
		chat: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			redactar: false,
			mensaje_nuevo: "",
			id_usuario: this.$ls.get("user").id_usuario,
			id_empresa: this.$ls.get("user").id_empresa_fk,
		}
	},

	watch: {
		//Hace focus al textarea del mensaje al escribir.
		redactar(value) {
			if(value) {
				setTimeout(function() {
					document.querySelector("#textarea-redactar").focus();
				}, 0);

			}
		}
	},
	
	computed: {
		destinatario() {
			return this.chat.usuarios.find(user => user.id_usuario !== this.id_usuario);
		},

		isChatGrupal() {
			return !!this.chat.moderador;
		},

		chatNuevo() {
			return this.chat.mensajes.length === 0;
		}
	},

	async mounted() {
		if (!this.chatNuevo) await this.insertarVistoMensajesDestinadosAMi();
	},

	methods: {
		...mapActions("ChatModule", [
			"createChat", 
			"deleteChat", 
			"sendMensajeIndividual", 
			"sendMensajeGrupal", 
			"insertVistoIndividual", 
			"insertVistoGrupal"
		]),

		async crearChatIndividualConMensaje() {
			const payload = {
				id_destinatario: this.destinatario.id_usuario,
				id_usuario: this.id_usuario,
				id_empresa: this.id_empresa,
				mensaje: this.mensaje_nuevo
			};
			const resCreateChat = await this.createChat(payload);
			if (!resCreateChat) {
				this.toastGenericError();
			}
		},

		async crearMensaje() {
			const payload = {
				id_usuario: this.id_usuario,
				id_empresa: this.id_empresa,
				mensaje: this.mensaje_nuevo
			};
			
			if (this.isChatGrupal) Object.assign(payload, { 
				id_grupo: this.chat.id_chat
			});
			else Object.assign(payload, { 
				id_destinatario: this.destinatario.id_usuario,
				id_chat: this.chat.id_chat
			});

			const resSendMsg = await this._sendMensaje(payload);
			if (!resSendMsg) {
				this.toastGenericError();
			}
		},

		//Crea un nuevo mensaje con el btn o presionando ENTER en el textarea dentro del detalle de chat.
		async enviarMensaje() {
			if (!this.chatNuevo) {
				await this.crearMensaje();
			} else {
				await this.crearChatIndividualConMensaje();
			}

			this.redactar = false;
			this.mensaje_nuevo = "";
		},

		async insertarVistoMensajesDestinadosAMi() {
			const payload = {
				id_empresa: this.id_empresa,
				id_usuario: this.id_usuario
			};

			if (this.isChatGrupal) Object.assign(payload, { id_grupo: this.chat.id_chat });
			else Object.assign(payload, { id_chat: this.chat.id_chat });

			const res = await this._insertVisto(payload);
			if (!res) {
				console.error(`Error enviando visto de chat ${this.chat.id_chat}`);
			}
		},

		_insertVisto(payload) {
			if (this.isChatGrupal) return this.insertVistoGrupal(payload);
			else return this.insertVistoIndividual(payload);
		},

		_sendMensaje(payload) {
			if (this.isChatGrupal) return this.sendMensajeGrupal(payload);
			else return this.sendMensajeIndividual(payload);
		},

		favoriteToggle() {
			this.chat.favorito = !this.chat.favorito;
		},

		async eliminarChat() {
			const payload = {
				id_usuario: this.id_usuario,
				id_chat: this.chat.id_chat,
				id_empresa: this.id_empresa
			};

			const res = await this.deleteChat(payload);
			if (!res) {
				this.toastGenericError();
			} else {
				this.toastChatDeleteSuccess();
				this.$emit('chatDeleted');
			}
		},

		volver() {
			this.$emit('volver');
		},

		showUsersNames(chat) {
			return chat.usuarios
				.map(user => `${user.primer_nombre} ${user.apellido_paterno}`)
				.join(", ");
		},

		//Agrega el estilo de globo blanco o gris en el chat.
		estiloMensaje(mensaje) {
			return this._isMyMessage(mensaje) ? "message-left align-self-start" : "message-right align-self-end";
		},
		estiloFecha(mensaje) {
			return this._isMyMessage(mensaje) ? "text-start" : "text-end";
		},
		estiloRemitente(mensaje) {
			return this._isMyMessage(mensaje) ? "message-left align-self-start" : "message-right align-self-end";
		},

		_isMyMessage(mensaje) {
			if (this.isChatGrupal) return mensaje.remitente.id_usuario === this.id_usuario; 
			else return mensaje.id_remitente === this.id_usuario;
		},

		//Hace resize del textarea al escribir el mensaje.
		textareaResize() {
			let textarea = document.querySelector("#textarea-redactar");
			if(this.texto === "") {
				textarea.style.height = "63px";
				return
			}
			textarea.style.height = "1px";
			textarea.style.height = (25 + textarea.scrollHeight) + "px";
		},
		
		toastChatDeleteSuccess() {
			this.$toast.open({
				message: "Se ha eliminado satisfactoriamente el chat.",
				type: "success",
				duration: 5000,
				position: "top-right",
			});
		}
	},

	filters: {
		chatDate(dateString) {
			return moment(dateString).format("DD/MM HH:mm");
		}
	}
}
</script>
<template>
	<section id="detalle-chat" class="d-flex flex-column flex-grow-1">
		<div class="d-flex justify-content-between align-items-center mb-4">
			<a 
				@click="volver()"
				href="javascript:"
				class="btn btn-custom-line-main btn-sm me-2"
			>
			<font-awesome-icon icon="fa-solid fa-angle-left" class="me-1"></font-awesome-icon>
			Volver
			</a>
		</div>
		<div class="d-flex mb-3">
			<div class="flex-grow-1">

				<div v-if="!isChatGrupal" class="d-flex align-items-center list-contactos-action">
					<div class="flex-shrink-0">
						<img 
							v-if="destinatario.imagen_perfil"
							width="48"
							height="48"
							class="img-object-cover rounded-circle"
							:src="destinatario.imagen_perfil"
							:alt="destinatario | userFullName | initials"
						>
					</div>
					<div class="flex-grow-1 ms-3">
						<p class="d-grid text-secondary mb-0">
							<strong class="ellipsis-custom"> {{ destinatario | userFullName }} </strong>
							<!-- DESARROLLO FUTURO: estado de conexión del interlocutor -->
							<!-- <span v-if="chat.online" class="text-secondary text-opacity-75 ellipsis-custom"> en línea </span>
							<span v-if="!chat.online" class="text-secondary text-opacity-75 ellipsis-custom"> offline </span> -->
						</p>
					</div>
				</div>

				<div v-else class="d-flex align-items-center list-contactos-action">
					<div class="flex-shrink-0">
						<img 
							v-if="chat.url_img_grupo"
							width="48"
							height="48"
							class="img-object-cover rounded-circle"
							:src="chat.url_img_grupo"
							:alt="chat.nombre_grupo | initials"
						>
					</div>
					<div class="flex-grow-1 ms-3">
						<p class="d-grid text-secondary mb-0">
							<strong class="ellipsis-custom"> {{ chat.nombre_grupo }} </strong>
							<span class="text-secondary text-opacity-75 small"> {{ showUsersNames(chat) }} </span>

						</p>
					</div>
				</div>

			</div>

			<div v-if="!isChatGrupal" class="d-flex align-items-center flex-shrink-0 ms-3">
				<a @click="eliminarChat()" href="javascript:" class="fs-4 color-main me-3">
					<font-awesome-icon icon="fa-solid fa-trash-can" ></font-awesome-icon>
				</a>
			</div>
		</div>
		<div class="d-flex flex-column flex-grow-1">
			<div class="card bg-gray border-0 flex-grow-1 mb-3">
				<div class="card-body d-flex flex-column-reverse p-4 overflow-chat">
					<div 
						v-for="mensaje in chat.mensajes"
						:key="mensaje.id_chat_mensaje"
						class="message d-flex flex-column"
						:class="estiloMensaje(mensaje)"
					>
						<small v-if="isChatGrupal" class="fw-bold" :class="estiloFecha(mensaje)">{{ mensaje.remitente.primer_nombre }}</small>
						{{ mensaje.mensaje }}
						<small :class="estiloFecha(mensaje)" style="font-size: 0.66em;">{{ mensaje.fecha_creacion | chatDate }}</small>
					</div>
				</div>
			</div>
			<div class="redactar flex-shrink-0">
				<div 
					v-if="!redactar"
					class="d-flex">
					<a @click="redactar = true" href="javascript:" class="redactar-btn w-100">
						<font-awesome-icon icon="fa-solid fa-face-laugh" class="pe-2 color-main"></font-awesome-icon>
						Escribe un mensaje
					</a>
				</div>
				<div 
					v-show="redactar"
					class="row">
					<div class="col-12">
						<textarea 
							@keyup="textareaResize()"
							@keydown.enter.exact.prevent
							@keyup.enter.exact="enviarMensaje()"
							id="textarea-redactar"
							rows="3" 
							class="redactar-textarea"
							v-model.trim="mensaje_nuevo"
							placeholder="Escribe un mensaje..."
							maxlength="200"
						></textarea>
						<a 
							@click="enviarMensaje()"
							class="redactar-enviar"
							href="javascript:"
						>
							<SendSvg/>
						</a>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<style lang="scss">

</style>